// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39uvc","colMin":"styles_colMin__1DIw9"};